import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { locizePlugin } from 'locize';

const backendOptions = {
    projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
    apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
    referenceLng: 'en',
}

i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.use(locizePlugin)
.init({
    lng: 'en',
    saveMissing: process.env.NODE_ENV === 'development' ? true : false,
    updateMissing: process.env.NODE_ENV === 'development' ? true : false,
    fallbackLng: 'en',    
    backend: backendOptions,
    debug: process.env.NODE_ENV === 'development' ? true : false,
    // keySeparator: false
    react: {
        bindI18n: 'languageChanged editorSaved'
    }
})

export default i18n